import { FC, useEffect, useState } from 'react'
import { IconButton, Modal, PrimaryButton } from '../../../ui'
import { Box } from '../../../ui'
import style from './style.m.less'
import { Alert, Pagination, message } from 'antd'
import ConsumerCard from './ConsumerCard'
import { getFindUsers } from './config'
import useRequest from '../../../hooks/useRequest'
import ConsumerFilters from './ConsumerFilters'
import { useTranslation } from 'react-i18next'

interface ISearchConsumer {
    isModalVisible: boolean
    setIsModalVisible: () => void
    userType?: number
    prevSelected?: string[]
    prevSelectedKey?: string
    uneditable?: boolean
    selectHandle: (consumer: any) => void
}

const PAGE_SIZE = 10

const DEFAULT_PAG = {
    page: 1,
    pageSize: PAGE_SIZE,
}

type PaginationType = {
    page?: number
    pageSize?: number
    f?: any
}

const SearchPrevConsumer: FC<ISearchConsumer> = ({
    isModalVisible,
    setIsModalVisible,
    prevSelected,
    prevSelectedKey,
    userType,
    selectHandle,
}) => {
    const { t } = useTranslation()
    const { fetch: userFetch, result: userList, dropState } = useRequest(getFindUsers)
    const [pagination, setPagination] = useState<PaginationType>(DEFAULT_PAG)
    const [filters, setFilters] = useState<any>({})
    const [currentConsumer, setCurrentConsumer] = useState<any>(undefined)

    const selectConsumer = (consumer: any) => {
        setCurrentConsumer({ ...consumer, company_name_short: consumer.company_name, user_type: 2 })
    }
    const getData = ({ page = 1, pageSize = 10, f = filters }: PaginationType) => {
        const params = new URLSearchParams({
            limit: pageSize,
            offset: (page - 1) * pageSize,
            ...f,
        })
        userFetch({
            addToLink: `?${params.toString()}`,
            errorCodeMessage: true,
        })
    }

    const updateFilters = (data: string | number | boolean, key: string, obj?: any) => {
        const updatedFilter =
            key === 'user_type'
                ? { ...(obj ? { ...obj } : { [key]: data }) }
                : {
                      ...filters,
                      ...(obj ? { ...obj } : { [key]: data }),
                  }
        if (key === 'user_type') {
            dropState()
        }
        setFilters(updatedFilter)
        setPagination({ page: 1, pageSize: pagination.pageSize })
    }

    const getUpselected = () => {
        selectHandle(currentConsumer)
        closeModal()
    }

    const find = () => {
        getData({ page: 1, pageSize: pagination.pageSize, f: filters })
    }

    const closeModal = () => {
        dropState()
        setIsModalVisible()
    }

    useEffect(() => {
        if (!isModalVisible) {
            setCurrentConsumer(undefined)
            setFilters({})
        }
    }, [isModalVisible])

    useEffect(() => {
        if (userList?.items === null) {
            message.error('Потребители с такими данными не найдены')
        }
    }, [userList])

    return (
        <Modal
            isModalVisible={isModalVisible}
            onCancel={closeModal}
            bodyStyle={{ width: '713px' }}
            footer={
                <Box width={'100%'}>
                    <Box
                        direction="row"
                        justify="space-between"
                        align="center"
                        margin="10px 0px 10px 0px"
                    >
                        <Box width={'100%'} align="flex-start">
                            {userList?.pagination.count > 10 && (
                                <Pagination
                                    pageSize={pagination.pageSize}
                                    current={pagination.page}
                                    total={userList?.pagination.count || 0}
                                    onChange={(page, pageSize) => {
                                        getData({ page, pageSize, f: filters })
                                        setPagination({ page, pageSize })
                                    }}
                                    showSizeChanger
                                />
                            )}
                            <Box direction="row" width={'100%'} justify="flex-end">
                                <PrimaryButton
                                    onClick={closeModal}
                                    value={t('documents.cancel')}
                                    isCancel
                                    customStyle={{ padding: '8px 16px' }}
                                />
                                <PrimaryButton
                                    onClick={getUpselected}
                                    value={t('certificateCard.choose')}
                                    disabled={!currentConsumer}
                                    customStyle={{ marginLeft: '16px', padding: '8px 16px' }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            }
        >
            <Box>
                <Box>
                    <div className={style.modalHeader}>Поиск потребителя среди ранее указанных</div>
                    {userType !== 0 && (
                        <Alert
                            className={style.resultAlert}
                            message="Поиск осуществляется по любому из заполненных полей"
                            type="info"
                            showIcon
                        />
                    )}
                    <ConsumerFilters userType={userType || 2} onChange={updateFilters} />
                    <Box width={100} margin="20px 0px 20px -10px">
                        <IconButton onClick={find} className={style.buttonMargin}>
                            {/*disabled={!Object.keys(filters).length}*/}
                            Найти
                        </IconButton>
                    </Box>
                </Box>
                <Box width={650} padding="10px 0px 0px 0px">
                    {(userList?.items?.length > 0 || userList || userList?.items) &&
                        (userList?.items || []).map((el: any) => (
                            <ConsumerCard
                                selected={el.user_id === currentConsumer?.user_id}
                                disabled={
                                    prevSelected?.includes(el[prevSelectedKey || 'user_id']) ||
                                    false
                                }
                                onClick={selectConsumer}
                                user={el}
                                key={el.user_id}
                            />
                        ))}
                </Box>
            </Box>
        </Modal>
    )
}

export default SearchPrevConsumer
